import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-countrydetails',
  templateUrl: './countrydetails.component.html',
  styleUrls: ['./countrydetails.component.css']
})
export class CountrydetailsComponent implements OnInit {

  @Input() data: any;
  public categoryList = [
    { 'name': 'Select Country', 'subcategories': ["India", 'NewZland', "Australia", "SouthAfrica", "England"] },
    { 'name': 'Select Language', 'subcategories': ["Telugu", 'Tamil', "Kannada", "Arabic", "Malayalmam"] }
  ]
  public selectedCategoryIndex = undefined;
  public selectedBookTypeIndex = undefined;

  public showSubCategoryOnly: boolean = false;
  public subCategoryArray = []

  public booksFilterTypes = [{ 'name': 'All', 'icon': 'icon-All-2' }, { 'name': 'ELE', 'icon': 'icon-ELE' }, { 'name': 'EBE', 'icon': 'icon-EBE' }];
  public newTempFilter = ['All', 'My Themes'];
  constructor() { }

  ngOnInit() {
  }

  updateCategoryIndex(index) {

    document.getElementsByClassName("globalpopup")[0]['style'].height = "auto";

    if (this.selectedCategoryIndex == index) {
      this.selectedCategoryIndex = undefined;
    } else {
      this.selectedCategoryIndex = index;
    }

    this.subCategoryArray.push(this.categoryList[index]);

  }

  hideSubCategoryArray() {
    this.selectedCategoryIndex = undefined;
    this.subCategoryArray.length = 0;
  }




}



// WEBPACK FOOTER //
// ./src/app/store/popups/countrydetails/countrydetails.component.ts